import { render, staticRenderFns } from "./Subnavbar.vue?vue&type=template&id=0f4b6318&scoped=true&"
import script from "./Subnavbar.vue?vue&type=script&lang=js&"
export * from "./Subnavbar.vue?vue&type=script&lang=js&"
import style0 from "./Subnavbar.vue?vue&type=style&index=0&id=0f4b6318&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4b6318",
  null
  
)

export default component.exports